module.exports = __webpack_public_path__ + "img/hr-tank-base-mask-2.a6648b31.png";